import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { createAddDocApplicantDetailsValidationSchema } from "../../../../../../yup/common/applicant/applicantDetailsValidationSchema";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepApplicant from "../../../../../../hooks/useStepApplicant";
import { initialAdditionalDocApplicantDetails } from "../../../../../../init/common/applicantDetailsInitialValues";
import {
  setStepApplicantEdited,
  setRequestIdentifier,
  completeApplicantStep,
} from "../../../../../../store/redux/slice/Forms/rudiAdditionalDocForm";
import AdditionalDocApplicantDetailsForm from "../../../common/form/applicant/AdditionalDocApplicantDetailsForm";

const RudiAdditionalDocStepApplicant = () => {
  const rudiAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RudiAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepApplicant(
    rudiAdditionalDocForm,
    baseEndpointPaths.rudiAdditionalDoc,
    createAddDocApplicantDetailsValidationSchema,
    setStepApplicantEdited,
    setRequestIdentifier,
    completeApplicantStep,
    initialAdditionalDocApplicantDetails,
    false,
    false,
    true,
  );

  useFormReset("RUDI_ADDITIONAL_DOCUMENTS", rudiAdditionalDocForm.applicantDetails, methods.reset);

  return <AdditionalDocApplicantDetailsForm methods={methods} onSubmit={onSubmit} hasRepresentativeCompany={true} />;
};
export default RudiAdditionalDocStepApplicant;
